import React from 'react';
import { CalendarIcon, TrendingUpIcon, UsersIcon, MessageSquareIcon } from 'lucide-react';
const AlgaWeeklySummaryWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-1087">
      <div className="p-4 border-b border-gray-200 flex items-center" data-id="element-1088">
        <div className="w-8 h-8 rounded-full overflow-hidden border-2 border-pink-500 mr-3" data-id="element-1089">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x28iigDaSByhSaf2N4iVm6/IMG_0007.png" alt="ALGA AI Assistant" className="w-full h-full object-cover" data-id="element-1090" />
        </div>
        <div data-id="element-1091">
          <h2 className="text-base font-semibold text-gray-800" data-id="element-1092">
            Sintesi Settimanale
          </h2>
          <p className="text-xs text-gray-500" data-id="element-1093">Powered by EIIS Intelligence</p>
        </div>
      </div>
      <div className="p-4" data-id="element-1094">
        <div className="space-y-4" data-id="element-1095">
          <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-1096">
            <h3 className="font-medium text-gray-800 text-sm mb-2 flex items-center" data-id="element-1097">
              <TrendingUpIcon size={16} className="mr-2 text-custom-green" data-id="element-1098" />
              Argomenti principali
            </h3>
            <ul className="text-sm text-gray-600 space-y-1.5" data-id="element-1099">
              <li className="flex items-start" data-id="element-1100">
                <span className="text-custom-green mr-2" data-id="element-1101">•</span>
                <span data-id="element-1102">Economia circolare nei processi produttivi</span>
              </li>
              <li className="flex items-start" data-id="element-1103">
                <span className="text-custom-green mr-2" data-id="element-1104">•</span>
                <span data-id="element-1105">Direttiva europea sulla plastic tax</span>
              </li>
              <li className="flex items-start" data-id="element-1106">
                <span className="text-custom-green mr-2" data-id="element-1107">•</span>
                <span data-id="element-1108">Strategie di transizione energetica</span>
              </li>
            </ul>
          </div>
          <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-1109">
            <h3 className="font-medium text-gray-800 text-sm mb-2 flex items-center" data-id="element-1110">
              <UsersIcon size={16} className="mr-2 text-custom-green" data-id="element-1111" />
              Membri più attivi
            </h3>
            <div className="space-y-2" data-id="element-1112">
              <div className="flex items-center" data-id="element-1113">
                <div className="w-6 h-6 rounded-full overflow-hidden mr-2" data-id="element-1114">
                  <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Laura Bianchi" className="w-full h-full object-cover" data-id="element-1115" />
                </div>
                <span className="text-sm text-gray-700" data-id="element-1116">Laura Bianchi</span>
                <span className="ml-auto text-xs text-gray-500" data-id="element-1117">12 post</span>
              </div>
              <div className="flex items-center" data-id="element-1118">
                <div className="w-6 h-6 rounded-full overflow-hidden mr-2" data-id="element-1119">
                  <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Marco Rossi" className="w-full h-full object-cover" data-id="element-1120" />
                </div>
                <span className="text-sm text-gray-700" data-id="element-1121">Marco Rossi</span>
                <span className="ml-auto text-xs text-gray-500" data-id="element-1122">8 post</span>
              </div>
              <div className="flex items-center" data-id="element-1123">
                <div className="w-6 h-6 rounded-full overflow-hidden mr-2" data-id="element-1124">
                  <img src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="Alessandro Verdi" className="w-full h-full object-cover" data-id="element-1125" />
                </div>
                <span className="text-sm text-gray-700" data-id="element-1126">Alessandro Verdi</span>
                <span className="ml-auto text-xs text-gray-500" data-id="element-1127">5 post</span>
              </div>
            </div>
          </div>
          <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-1128">
            <h3 className="font-medium text-gray-800 text-sm mb-2 flex items-center" data-id="element-1129">
              <MessageSquareIcon size={16} className="mr-2 text-custom-green" data-id="element-1130" />
              Post più discussi
            </h3>
            <div className="space-y-3" data-id="element-1131">
              <div className="text-sm text-gray-600" data-id="element-1132">
                <p className="font-medium" data-id="element-1133">
                  Strategie di transizione energetica nel manifatturiero
                </p>
                <p className="text-xs text-gray-500" data-id="element-1134">24 commenti • 12 like</p>
              </div>
              <div className="text-sm text-gray-600" data-id="element-1135">
                <p className="font-medium" data-id="element-1136">
                  Direttiva europea per la plastic tax
                </p>
                <p className="text-xs text-gray-500" data-id="element-1137">17 commenti • 8 like</p>
              </div>
            </div>
          </div>
          <div className="p-3 bg-white rounded-lg border border-gray-200" data-id="element-1138">
            <h3 className="font-medium text-gray-800 text-sm mb-2 flex items-center" data-id="element-1139">
              <CalendarIcon size={16} className="mr-2 text-custom-green" data-id="element-1140" />
              Eventi recenti
            </h3>
            <div className="text-sm text-gray-600" data-id="element-1141">
              <p className="font-medium" data-id="element-1142">
                Webinar: Circular Economy for Business
              </p>
              <p className="text-xs text-gray-500" data-id="element-1143">
                2 giorni fa • 28 partecipanti
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default AlgaWeeklySummaryWidget;